import * as React from "react";
import { forwardRef } from "react";
const SvgMinusNegative = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "2.5em", height: "2.5em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 20H32", stroke: "#281E38", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMinusNegative);
export default ForwardRef;
